'use strict';

import angular from 'angular';
import Share from './share.controller';

export default angular.module('bfastCaptureManagerApp.application.share', [])
  .controller('AppShareController', Share)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/share/index.js